module.exports = __webpack_public_path__ + "static/gatsby-4de34260d4bdccfa1b133c3e57061037.png";